import ToggleSwitch from '../../../Inputs/ToggleSwitch';

const SettingsToggleRow = ({label, isActive, onClick}) => (
    <div className='flex items-center justify-between px-4 py-3'>
        <span className='text-sm'>{label}</span>
        <ToggleSwitch isActive={isActive} onClick={onClick} isOnlineCheck={false} />
    </div>
);

export default SettingsToggleRow;
